import { render, staticRenderFns } from "./StoresTab.vue?vue&type=template&id=46a9a73e"
import script from "./StoresTab.vue?vue&type=script&lang=js"
export * from "./StoresTab.vue?vue&type=script&lang=js"
import style0 from "./StoresTab.vue?vue&type=style&index=0&id=46a9a73e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports